import { getCurrentInstance } from 'vue'

const fallbackUidMap = new WeakMap<object, string>()

const createFallbackUid = (): string => {
  if (globalThis.crypto?.randomUUID) {
    return `fallback-${globalThis.crypto.randomUUID()}`
  }

  return `fallback-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

const getFallbackUid = (vm: object): string => {
  const cachedUid = fallbackUidMap.get(vm)
  if (cachedUid) {
    return cachedUid
  }

  const newUid = createFallbackUid()
  fallbackUidMap.set(vm, newUid)

  return newUid
}

export default {
  methods: {
    getUuidInstanceUid (): number | string {
      const vm = this as { $?: { uid?: number } }
      const currentInstance = getCurrentInstance()

      if (currentInstance?.uid !== undefined) {
        return currentInstance.uid
      }

      if (vm.$?.uid !== undefined) {
        return vm.$.uid
      }

      return getFallbackUid(this as object)
    },
    uuid (suffix: string, prefix = 'uid'): string {
      return `${prefix}-${this.getUuidInstanceUid()}-${suffix}`
    },
  },
}
